import {gql} from '@apollo/client'

export const RESPONSES_WITH_ITEM = gql`
  query responsesWithItem($everplanId: Int!) {
    responsesWithItem(everplanId: $everplanId) {
      id
      displayText
      groupId
    }
  }
`
